const DOC_LABELS = {
  license: "License",
  insurance: "Insurance",
  registration: "Registration",
};

const formatDate = (value) => {
  if (!value) return "Not provided";
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? "Not provided" : d.toLocaleDateString("en-US");
};

/**
 * Summary pill for a driver's license / insurance / registration expiry.
 * `expiry` is the object the backend attaches to driver docs (getDriverExpiryStatus).
 */
export default function DocumentExpiryBadge({ expiry, documentsExpired }) {
  if (!expiry?.documents) {
    return <span className="text-muted" style={{ fontSize: "0.85rem" }}>N/A</span>;
  }

  const docs = expiry.documents;
  const tooltip = Object.keys(DOC_LABELS)
    .map((key) => {
      const doc = docs[key] || {};
      let state = formatDate(doc.date);
      if (doc.expired) state += " (expired)";
      else if (typeof doc.daysLeft === "number") state += ` (${doc.daysLeft} days left)`;
      return `${DOC_LABELS[key]}: ${state}`;
    })
    .join("\n");

  const missing = Object.keys(DOC_LABELS).filter((key) => docs[key]?.missing);
  const soonest = expiry.soonestDaysLeft;

  let className = "status-active";
  let text = "Valid";
  if (documentsExpired || expiry.anyExpired) {
    className = "status-inactive";
    text = "Expired";
  } else if (typeof soonest === "number" && soonest <= 30) {
    className = "status-pending";
    text = `Expires in ${soonest}d`;
  } else if (missing.length) {
    className = "status-pending";
    text = "Dates missing";
  }

  return (
    <span className={`status-pill ${className}`} title={tooltip} style={{ whiteSpace: "nowrap" }}>
      {text}
    </span>
  );
}
